(function () {
  function bindMobileSubnav(page) {
    const toggle = page.querySelector('.flightxfj-list-mobilemenuaName');
    const menu = page.querySelector('.flightxfj-list-mobilemenu > ul');
    if (!toggle || !menu) return;

    toggle.addEventListener('click', () => {
      const open = menu.classList.toggle('is-open');
      toggle.classList.toggle('is-open', open);
    });
  }

  function initEnterpriseV3Page() {
    const page = document.querySelector('.cs-enterprise-v3-page');
    if (!page) return;

    page.addEventListener('click', (event) => {
      const menuLeft = event.target.closest('.flightxfj-list-menuLeft');
      if (menuLeft) {
        window.scrollTo({ top: 0, behavior: 'auto' });
      }
    });

    bindMobileSubnav(page);

    if (window.WOW) {
      try {
        new window.WOW({ live: false }).init();
      } catch (_) {}
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initEnterpriseV3Page);
  } else {
    initEnterpriseV3Page();
  }
})();
